// import { useEffect, useState } from 'react';
import "./home.css"
import Body from '../body/body';

import Header from '../header/header';
import Footer from '../footer/footer';
import TopPage from '../../Components/topPage/topPage';

// import api from '../../api/api';
// import Cookies from 'universal-cookie';

import { WhiteLabelContext } from "../../context/index";
import { useContext } from "react";

function Home() {
  const context = useContext(WhiteLabelContext);
  return (
    <>
      <div className="Home">
        <Header contexto={context.whitelabel} />
        <Body contexto={context.whitelabel} />        
        {context.whitelabel.identify === "certificadodigital" && <Footer contexto={context.whitelabel}/>}
        <TopPage />
      </div>
    </>
  );
}

export default Home;